/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgOtherCollisionWaiver32(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={32}
      height={32}
      fill='none'
      viewBox='0 0 32 32'
      {...props}
    >
      <mask
        id='other-collision-waiver-32_svg__a'
        width={30}
        height={18}
        x={1}
        y={7}
        maskUnits='userSpaceOnUse'
      >
        <path fill='#fff' d='M31 7H1.5v18H31V7z' />
      </mask>
      <g
        stroke='currentColor'
        strokeMiterlimit={5}
        strokeWidth={1.5}
        mask='url(#other-collision-waiver-32_svg__a)'
      >
        <path d='M1.5 11.5a4.5 4.5 0 100-9 4.5 4.5 0 000 9zM1.5 29.5a4.5 4.5 0 100-9 4.5 4.5 0 000 9zM31 11.5a4.5 4.5 0 100-9 4.5 4.5 0 000 9zM31 29.5a4.5 4.5 0 100-9 4.5 4.5 0 000 9zM16.523 20.831a5 5 0 100-10 5 5 0 000 10z' />
      </g>
      <path
        stroke='currentColor'
        strokeMiterlimit={5}
        strokeWidth={1.5}
        d='M31 7H1.5v18H31V7zM3 31L29.5 1'
      />
    </svg>
  );
}

export default SvgOtherCollisionWaiver32;
